// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"checkbox-module--checkbox--277q5","checkmark":"checkbox-module--checkmark--2EOO8"};